// extracted by mini-css-extract-plugin
export default {"wrap":"NotFoundPage_wrap__WzxvA","card":"NotFoundPage_card__bpLBO","kicker":"NotFoundPage_kicker__3q687","actions":"NotFoundPage_actions__vryyH"};